import { SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';
import { TextField } from '@material-ui/core';

interface RejectRevisionProps {
  loanId: number;
  drawId: number;
  afterActionExecuted: () => void;
}

export const RejectRevision = observer(({ loanId, drawId, afterActionExecuted }: RejectRevisionProps) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.sendRejectionReason(drawId, afterActionExecuted);
  }

  return (
    <SubmitDialog
      title="Reject Revision"
      open={drawActionsStore.isRejectRevisionDialogOpen}
      body={
        <TextField
          variant="outlined"
          label="Please enter the reason you are rejecting this revision"
          value={drawActionsStore.rejectReason}
          onChange={(e) => drawActionsStore.setRejectReason(e.target.value)}
          multiline
          rows={3}
          margin="normal"
          fullWidth
          style={{ background: 'white' }}
        />
      }
      handleClose={() => drawActionsStore.setIsRejectRevisionDialogOpen(false)}
      handleOk={confirmHandler}
      cancelButtonText='Cancel'
    />
  );
});
